import { Table, TableBody, TableHead, TableRow, TableCell, Typography, Box, Divider } from '@mui/material';
import DenseCellSm from 'components/common/table/styled-dense-cell';
import TableCommentRow from 'components/common/table/table-comment-row';
import { SubRow } from 'components/common/table/table-data-row/rows';
import _ from 'lodash';
import { IPerformanceSummaryTableProps } from 'models/loan-projection/performance-summary';
import { formatNumber } from 'utils/common-utils';
import { NumberDenseCell } from 'components/common/table/NumberDenseCell';

interface IProps extends IPerformanceSummaryTableProps {
  data: any;
}
export default function DebtDetails({ t, totalYears, data, control }: IProps) {
  return (
    <Box sx={{ mt: 2 }}>
      <Box sx={{ pl: 0.5, pr: 0.5, mt: 1, mb: 1 }}>
        <Typography variant="caption">
          <b>{t('loanProjection.performanceSummary.debtDetails')}</b>
        </Typography>
        <Divider />
      </Box>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell
              align="center"
              width={'25%'}
              sx={{
                background: '#F8F8F8',
                borderRight: '1px solid rgba(224, 224, 224, 1)',
              }}>
              <Typography>
                <b>Year ended March 31</b>
              </Typography>
            </TableCell>
            {_.map(totalYears, (year: string) => (
              <TableCell
                key={year}
                align="center"
                sx={{ borderRight: '1px solid rgba(224, 224, 224, 1)', background: '#F8F8F8' }}>
                <Typography>
                  <b>{year}</b>
                </Typography>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <DenseCellSm>Long term debt (LTD) (A)</DenseCellSm>
            {_.map(totalYears, (_, i: number) => {
              return <NumberDenseCell key={i}>{formatNumber(data[i].longTermDebts)}</NumberDenseCell>;
            })}
          </TableRow>
          <TableRow>
            <DenseCellSm>Short term debt (STD) (B)</DenseCellSm>
            {_.map(totalYears, (_, i: number) => {
              return <NumberDenseCell key={i}>{formatNumber(data[i].shortTermDebts.value)}</NumberDenseCell>;
            })}
          </TableRow>
          <SubRow
            title="Current portion of LTD-CPLTD (B1)"
            data={_.map(totalYears, (_, i: number) => {
              return (
                <NumberDenseCell key={i}>{formatNumber(data[i].shortTermDebts.currentPortion)}</NumberDenseCell>
              );
            })}
          />
          <SubRow
            title="Other working capital STD (B2)"
            data={_.map(totalYears, (_, i: number) => {
              return (
                <NumberDenseCell key={i}>
                  {formatNumber(data[i].shortTermDebts.projOtherWorkingCapital)}
                </NumberDenseCell>
              );
            })}
          />
          <TableRow>
            <DenseCellSm>WC bank finance (C)</DenseCellSm>
            {_.map(totalYears, (_, i: number) => {
              return <NumberDenseCell key={i}>{formatNumber(data[i].wcBankFinance)}</NumberDenseCell>;
            })}
          </TableRow>
          <TableRow>
            <DenseCellSm>Total Debt (w/o Gtee) ( A+B+C)</DenseCellSm>
            {_.map(totalYears, (_, i: number) => {
              return <NumberDenseCell key={i}>{formatNumber(data[i].totalDebtWithoutGtee)}</NumberDenseCell>;
            })}
          </TableRow>
          <TableRow>
            <DenseCellSm>Guarantee* (D)</DenseCellSm>
            {_.map(totalYears, (_, i: number) => {
              return <NumberDenseCell key={i}>{formatNumber(data[i].guarantee)}</NumberDenseCell>;
            })}
          </TableRow>
          <TableRow>
            <DenseCellSm>
              <b>Total Debt (A+B+C+D)</b>
            </DenseCellSm>
            {_.map(totalYears, (_, i: number) => {
              return (
                <NumberDenseCell heading key={i}>
                  {formatNumber(data[i].totalDebt)}
                </NumberDenseCell>
              );
            })}
          </TableRow>
        </TableBody>
      </Table>
    </Box>
  );
}
